class DeliveryCountdown extends HTMLElement {
    constructor() {
        super();
        this.targetDate = null;
        this.countryCode = this.getAttribute('country_code');
        this.init();
    }

    async isUserInUK() {
        // Early return if country code is already set
        if (this.countryCode === 'GB') {
            return true;
        }

        // Check Shopify.country first to avoid API call
        if (window.Shopify?.country) {
            return window.Shopify.country === 'GB';
        }

        // Cache API response
        const cachedCountryCode = sessionStorage.getItem('countryCode');
        if (!cachedCountryCode) {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                
                const response = await fetch('https://ipapi.co/json/', {
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                
                const data = await response.json();
                sessionStorage.setItem('countryCode', data.country_code);
                return data.country_code === 'GB';
            } catch (e) {
                console.error('Geolocation check failed', e);
                return false;
            }
        }

        return cachedCountryCode === 'GB';
    }

    getNextDeliveryDay() {
        const now = new Date();
        const nextDay = new Date(now);
        const day = now.getDay();
        const hour = now.getHours();

        const isWeekend = day === 6 || day === 0;
        const isFridayAfternoon = day === 5 && hour >= 14;

        if (isWeekend) {
            if (day === 6) {
                nextDay.setDate(nextDay.getDate() + 3);
            } else {
                nextDay.setDate(nextDay.getDate() + 2);
            }
        } else if (isFridayAfternoon) {
            nextDay.setDate(nextDay.getDate() + 4);
        } else if (hour >= 14) {
            nextDay.setDate(nextDay.getDate() + 2);
        } else {
            nextDay.setDate(nextDay.getDate() + 1);
        }

        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return dayNames[nextDay.getDay()];
    }

    getNext2PM() {
        const now = new Date();
        const next2PM = new Date();
        next2PM.setHours(14, 0, 0, 0);

        if (now >= next2PM) {
            next2PM.setDate(next2PM.getDate() + 1);
        }

        return next2PM;
    }

    updateDayName() {
        const dayNameElement = this.querySelector('.delivery-countdown__date');
        dayNameElement.textContent = this.getNextDeliveryDay();
    }

    updateCountdown() {
        const now = new Date();
        const timeRemaining = this.targetDate - now;
        const countdownElement = this.querySelector('.delivery-countdown__countdown');

        if (timeRemaining <= 0) {
            countdownElement.innerHTML = "It's 2 PM!";
            return;
        }

        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
        countdownElement.innerHTML = `${hours}hrs ${minutes}m ${seconds}s`;
    }

    async init() {
        const userInUK = await this.isUserInUK();
        const container = this.querySelector('.delivery-countdown__container');

        if (userInUK) {
            container.style.display = 'block';
            this.targetDate = this.getNext2PM();
            setInterval(() => this.updateCountdown(), 1000);
            this.updateCountdown();
            this.updateDayName();
        } else {
            container.style.display = 'none';
        }
    }
}

customElements.define('delivery-countdown', DeliveryCountdown);
